import {
  SET_MEASUREMENT_TOOL,
  DISABLE_MEASUREMENT_TOOLS,
  ADD_POI_POINT,
  RESET_ADD_POI_TOOL,
  RESET_MANAGAE_POI_TOOL,
  ADD_HOTEL_POINT,
  RESET_ADD_HOTEL_TOOL,
  RESET_MANAGAE_HOTEL_TOOL,
  TOGGLE_SPATIAL_ANALYSIS,
  CHANGE_SPATIAL_ANALYSIS_CONFIG,
  CLEAR_SPATIAL_ANALYSIS_CONFIG,
  ONCLICK_PARCEL,
  RECTANGLE_ZOOM_IN,
  BUILDING_DRAW_TOOL_TOGGLE,
  BUILDING_DRAW_TOOL_GET_POINT,
  BUILDING_DRAW_TOOL_DATA,
  BUILDING_DRAW_TOOL_PARCELS,
  BUILDING_DRAW_TOOL_VALIDATE,
  BUILDING_DRAW_TOOL_PDF,
  RECTANGLE_BLOCKING_TOGGLE,
  FETCH_DRAW_TOOL_LIMITS_REQUEST,
  FETCH_DRAW_TOOL_LIMITS_SUCCESS,
  FETCH_DRAW_TOOL_LIMITS_FAIL,
} from '../constants';

// Disables current measurement tool
export function disableMeasurementTool() {
  return ({ type: DISABLE_MEASUREMENT_TOOLS });
}

// Enables measurement tool according to tool name - it may be only one tool enabled at time
export function setMeasurementTool(tool) {
  return ({ type: SET_MEASUREMENT_TOOL, payload: { tool } });
}

export function addPoiPoint(point) {
  return ({ type: ADD_POI_POINT, payload: { point } });
}

export function addHotelPoint(point) {
  return ({ type: ADD_HOTEL_POINT, payload: { point } });
}

export function resetAddPoiTool() {
  return ({ type: RESET_ADD_POI_TOOL });
}

export function resetManagePoiTool() {
  return ({ type: RESET_MANAGAE_POI_TOOL });
}

export function resetManageHotelTool() {
  return ({ type: RESET_MANAGAE_HOTEL_TOOL });
}

export function resetAddHotelTool() {
  return ({ type: RESET_ADD_HOTEL_TOOL });
}

export function toggleAnalysis() {
  return ({ type: TOGGLE_SPATIAL_ANALYSIS });
}

export function changeAnalysisConfig(key, value) {
  return ({ type: CHANGE_SPATIAL_ANALYSIS_CONFIG, payload: { key, value } });
}

export function clearAnalysis() {
  return ({ type: CLEAR_SPATIAL_ANALYSIS_CONFIG });
}

export function onClickParcel(prop) {
  return ({ type: ONCLICK_PARCEL, payload: { prop } });
}

export function zoomingRectangle(prop) {
  return ({ type: RECTANGLE_ZOOM_IN, payload: { prop } });
}

export function blockingRectangle(prop) {
  return ({ type: RECTANGLE_BLOCKING_TOGGLE, payload: { prop } });
}

export function toggleDrawBuilding(display) {
  return ({ type: BUILDING_DRAW_TOOL_TOGGLE, payload: { display } });
}

export function drawBuildingGetPoint(position) {
  return ({ type: BUILDING_DRAW_TOOL_GET_POINT, payload: { position } });
}

export function drawBuildingData(data) {
  return ({ type: BUILDING_DRAW_TOOL_DATA, payload: { data } });
}

export function drawBuildingParcels(parcels) {
  return ({ type: BUILDING_DRAW_TOOL_PARCELS, payload: { parcels } });
}

export function drawBuildingValidate(valid) {
  return ({ type: BUILDING_DRAW_TOOL_VALIDATE, payload: { valid } });
}

export function drawBuildingPDF(print) {
  return ({ type: BUILDING_DRAW_TOOL_PDF, payload: { print } });
}

export function getLimits(prefix, lat, lng) {
  if (prefix === null) {
    return ({ type: FETCH_DRAW_TOOL_LIMITS_SUCCESS, payload: null });
  }
  return dispatch => {
    const url = `${process.env.API_URL}/einvest/${prefix}/geodata?lat=${lat}&lng=${lng}`;
    dispatch({ type: FETCH_DRAW_TOOL_LIMITS_REQUEST });
    return fetch(url, {
      method: 'GET',
    })
    .then(async (response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        dispatch({ type: FETCH_DRAW_TOOL_LIMITS_FAIL });
        throw { error: 'Bład przy pobieraniu limitów dla narzędznia rysownaia', status: response.status, text: await response.text() };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_DRAW_TOOL_LIMITS_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      console.info(error);
    });
  };
}



// WEBPACK FOOTER //
// src/actions/mapTools.js